import { Link } from 'react-router-dom';
import { styled } from '@mui/system';

export const SidebarItemStyled = styled(Link, {
  shouldForwardProp: (props) => props !== 'isSelected',
})<{ isSelected: boolean }>(({ isSelected }) => {
  return {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
    textDecoration: 'none',
    transition: 'color 300ms',
    color: isSelected ? 'var(--color-white)' : 'var(--color-greyscale-200)',
    '&:hover': {
      color: 'var(--color-white)',
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
    },

    '.sidebar-item-icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      transition: 'background-color 300ms',
      borderRadius: 'var(--radius-lg)',
      color: isSelected ? 'var(--color-white)' : 'var(--color-greyscale-200)',
      backgroundColor: isSelected ? 'rgba(133, 184, 255, 0.25)' : 'transparent',
      borderLeft: isSelected ? '2px solid var(--color-primary-600)' : '2px solid transparent',

      '&:hover': {
        backgroundColor: 'rgba(133,184,255,.2)',
        color: 'var(--color-white)',
      },
      '& svg': {
        width: '20px',
        height: '20px',
      },
      '& svg path[fill]': {
        fill: 'currentColor',
      },
    },
  };
});
